export default __webpack_public_path__ + "static/headphones-845271404951318e77260564a4dfa9b4.png";